import { isBefore } from 'date-fns'
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux'
import { Action } from 'redux'
import { getNestedProperty } from '@opallabs/lambda'
import { actions, getters } from '@opallabs/wormhole'
import { Notification, State } from '@opallabs/wormhole/types'
import { DispatchProps, OwnProps, StateProps } from './types'
import { NotificationsPanel } from '.'

const mapStateToProps: MapStateToProps<StateProps, OwnProps, State> = (
  state
) => {
  // Assume we're loading unless the loader is explicitly set to false
  const isLoading =
    getNestedProperty(state, 'loaders', 'downloads') === undefined
      ? true
      : getNestedProperty(state, 'loaders', 'downloads')

  return {
    isLoading,
    notifications: getters.mapPersonalPanelDownloads(state).sort((a, b) => {
      if (isBefore(a.timestamp, b.timestamp)) {
        return 1
      }
      if (isBefore(b.timestamp, a.timestamp)) {
        return -1
      }
      return 0
    }),
  }
}

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  ownProps
) => ({
  createCheckpoint: (downloads: Notification[]): Action =>
    dispatch(
      actions.createCheckpoints({
        tab: 'Download',
        items: downloads,
      })
    ),
  onItemClick: (notification: Notification): void => {
    ownProps.onNotificationClick(notification)
  },
  onRemoveNotification: (id: string): void => {
    dispatch(actions.removeNotification(id))
  },
  getNotifications: ({ page = 0, pageSize = 40 }): Action =>
    dispatch(actions.getNotifications({ parent: 'downloads', pageSize, page })),
})

export const ConnectedDownloadPanel = connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationsPanel)
